import { ReactNode } from 'react'
import Layout from '../../../common/components/Layout'
import styles from './ProfileBase.module.css'
import Button from '../../../common/components/Button'
import { getCurrentUsername } from '../../../common/utils/cognito'
import { t } from 'i18next'

interface ProfileBaseProps {
  title: string
  backButtonAction?: () => void
  buttonTitle: string
  onButtonClick: () => void
  children: ReactNode
}

const ProfileBase = ({
  title,
  backButtonAction,
  buttonTitle,
  onButtonClick,
  children,
}: ProfileBaseProps) => {
  const userEmail = getCurrentUsername()

  return (
    <Layout
      hasBackButton
      backButtonAction={backButtonAction}
      contentStyles={{ display: 'flex' }}
    >
      <div className={styles.profileContainer}>
        <div className={styles.header}>
          <div className={styles.title}>{title}</div>
          <div className={styles.subtitle}>
            {t('profile.user')}: {userEmail}
          </div>
          <div className={styles.description}>{t('profile.disclaimer')}</div>
        </div>
        {children}
        <Button title={buttonTitle} onClick={onButtonClick} />
      </div>
    </Layout>
  )
}

export default ProfileBase
